import React, { Component, createRef, useReducer, useEffect } from "react";
import AppContext from "../AppContext"
import { Avatar, Layout, Menu, Modal, Form, Input, Button } from "antd";
import { NavLink, Redirect } from "react-router-dom";
import {
  logout
} from '../../Controller/Navigation';
import Profile from "../Profile_reset"
import ContactList from "../Management/ContactList";

import Badge from '@mui/material/Badge';
import { GetTranslation } from '../../Models/shared/general';
import { categories, dashboardpages, pages, testpages, remidnerdpages, taskpages, paymentpages, contactlistpages } from "../../Models/shared/master"

import {
  DownCircleOutlined,
  KeyOutlined,
  CloseOutlined,
  HomeOutlined,
  ContactsOutlined,
  TableOutlined,
  AliwangwangOutlined
}
  from "@ant-design/icons";

const { SubMenu } = Menu;
const { Header, Sider } = Layout;


const userlang = navigator.language || navigator.userLanguage;
const onPressNewTask = async (val) => {


  localStorage.setItem("action", "opennewtask")
  localStorage.setItem("taskuserid", "self")
  // if (val != undefined && val != "") {

  // }

};

const handleUserManualMenuClick = (e) => {

  window.open('https://qc9sk2.naxgo.online/media/documents/Naxgo User Manual.pdf', '_blank');

};

const logoutN = (

  <Menu.Item

    icon={logout[0].icon}
    key={999}>
    <NavLink key="navlinkLogout" to={logout[0].path}>
      {logout[0].title}
    </NavLink>
  </Menu.Item>
)
class App extends Component {
  static contextType = AppContext;
  constructor(props) {
    super(props)
    this.state = {
      collapsed: true,
      modalVisible: false,
      pendingContact: 0,
    }
    window.updatePendingContact = this.updatePendingContact; // Exposing the function globally

    if (props.isMob) {
      this.Menu = createRef()
    }
  }


  // Function to update pending contact count from local storage
  updatePendingContact = () => {
    const contactCount = localStorage.getItem('pendingcontact')
      ? parseInt(localStorage.getItem('pendingcontact'), 10)
      : 0;

    // Logging to verify the value from localStorage
    console.log('Pending contact from localStorage:', contactCount);

    this.setState({ pendingContact: contactCount }, () => {
      // Log the state after it's updated
      console.log('State updated in updatePendingContact:', this.state.pendingContact);
    });
  };


  // Lifecycle method to set up event listener when component mounts
  componentDidMount() {
    console.log('Component did mount, setting initial pendingContact state');
    this.updatePendingContact();
    window.addEventListener('storage', this.updatePendingContact);
    console.log('Storage event listener added');
  }

  // Cleanup event listener when component unmounts
  componentWillUnmount() {
    console.log('Component will unmount, removing storage event listener');
    window.removeEventListener('storage', this.updatePendingContact);
  }

  // Log when component updates
  componentDidUpdate(prevProps, prevState) {
    if (prevState.pendingContact !== this.state.pendingContact) {
      console.log('componentDidUpdate - pendingContact updated:', this.state.pendingContact);
    }
  }
  profileN = (
    <Menu.Item icon={<KeyOutlined />}>
      <Profile
        userid={this.props.UserIdentity.userid}
      />
    </Menu.Item>
  )
  profileContact = (
    <Menu.Item
      key={"2013"} icon={<ContactsOutlined />}>
      <NavLink to={"/ContactList"}>
        {"Contact List"}
      </NavLink>
    </Menu.Item>
  )

  profileOutsider = (
    <Menu.Item
      key={"2001"} icon={<TableOutlined />}>
      <NavLink to={"/TaskManagement"}>
        {"Task Management"}
      </NavLink>
    </Menu.Item>
  )




  handleClicks = (e) => {
    if (this.Menu && this.props.isMob) {
      if (this.Menu.current && this.Menu.current.contains(e.target) && this.state.collapsed) {
        this.setState({ collapsed: false })
      }
      else {
        if (this.Menu.current && !this.Menu.current.contains(e.target) && !this.state.collapsed) {
          this.setState({ collapsed: true })
        }
      }

    }
  }
  render() {
    //const useraccess = ["nicholas","stevent","bee","waibein","nickerson", "allen", "roger"];
    const useraccess = ["60ebde816d150ba31d16a879", "62b285b616cfa6b8352cd44a", "60ebf3b2e0741b107ce0d8a6", "60ebf1d6aebe39153046d6d6"
      , "60ebf235e0741b107ce0d855", "60ebf38ae0741b107ce0d89e", "60ebf36ae0741b107ce0d89a", "60ec1a20e840169d91254cc8"];

    const usertesting = ['60ebde816d150ba31d16a879', '62b285b616cfa6b8352cd44a', '60ebf3b2e0741b107ce0d8a6', '60ebf1d6aebe39153046d6d6',
      '61d25883cddb0fb407663477', '60eba6f748c6fe1a99ce6994', '62734dd9575e70031514125e', '60f11782c8ab5e5708c10f8b']
    const userpayeesetting = ['60ebf3b2e0741b107ce0d8a6', '60ebf1d6aebe39153046d6d6',
      '62734dd9575e70031514125e', '61d25883cddb0fb407663477']

    if ((localStorage.getItem('naxver')) != "1.1") {
      return <Redirect to={logout[0].path} />
    }

    const { pendingContact } = this.state;

    console.log('Rendering - pendingContact:', pendingContact); // Log during rendering


    return (
      <>
        {this.props.isMob ?

          <>
            {
              this.state.collapsed ?

                <Header
                  style={{ padding: "0px" }}
                  theme="dark"
                >
                  <Menu
                    inlineIndent={4}
                    mode="horizontal"
                    theme="dark">

                    <SubMenu
                      style={{ float: "right" }}
                      key={"Logggout"}
                      icon={
                        pendingContact > 0 ?
                          <Avatar
                            style={{
                              backgroundColor: '#7265e6',
                              verticalAlign: "middle",
                              cursor: "pointer"
                            }}
                            size="default">
                            {this.context.UserIdentity.username[0]}
                            {this.context.UserIdentity.username[1]}
                          </Avatar>

                          :
                          <Avatar
                            style={{
                              backgroundColor: '#7265e6',
                              verticalAlign: "middle",
                              cursor: "pointer"
                            }}
                            size="default">
                            {this.context.UserIdentity.username[0]}
                            {this.context.UserIdentity.username[1]}
                          </Avatar>}>
                      {this.profileContact}
                      {this.profileN}
                      {logoutN}
                    </SubMenu>
                    {dashboardpages.map((category, index) => {

                      return (
                        <>
                          <Menu.Item key={index.toString() + category.key.toString()} icon={category.icon} >
                            <NavLink to={category.path}>

                            </NavLink>
                          </Menu.Item>
                        </>
                      )
                    }
                    )}

                    <Menu.Item>
                      <a href="/TaskManagement" onClick={() => onPressNewTask()}><AliwangwangOutlined /></a>
                    </Menu.Item>

                    {contactlistpages.map((category, index) => {

                      return (
                        <>

                          <Menu.Item key={index.toString() + category.key.toString()} icon={category.icon} >

                            <NavLink to={category.path}>
                              {
                                pendingContact > 0 ?
                                  <>
                                    <Badge badgeContent={pendingContact} color="success">

                                    </Badge>
                                  </>
                                  :
                                  <>
                                  </>
                              }

                            </NavLink>
                          </Menu.Item>
                        </>
                      )
                    }
                    )}
                    {/* {remidnerdpages.map((category, index) => {

                      return (
                        <>
                          <Menu.Item key={index.toString() + category.key.toString()} icon={category.icon} >
                            <NavLink to={category.path}>

                            </NavLink>
                          </Menu.Item>
                        </>
                      )
                    }
                    )} */}
                    {/* {paymentpages.map((category, index) => {
                      if (this.context.UserIdentity.userid == "61d25883cddb0fb407663477" ||
                        this.context.UserIdentity.userid == "60eba6f748c6fe1a99ce6994" ||
                        this.context.UserIdentity.userid == "62b285b616cfa6b8352cd44a") {
                        return (
                          <>
                            <Menu.Item key={index.toString() + category.key.toString()} icon={category.icon} >
                              <NavLink to={category.path}>

                              </NavLink>
                            </Menu.Item>
                          </>
                        )
                      }

                    }
                    )} */}


                    {taskpages.map((category, index) => {
                      if (this.context.UserIdentity.companyid === "outsider") {
                        return (
                          <>
                            <Menu.Item key={index.toString() + category.key.toString()} icon={category.icon} >
                              <NavLink to={category.path}>
                                Task Management
                              </NavLink>
                            </Menu.Item>
                          </>
                        )
                      }

                    }
                    )}
                    <Menu.Item
                      onClick={() => { this.setState({ collapsed: false }) }}
                      icon={<DownCircleOutlined />}>
                      {GetTranslation(userlang, "Open Menu")}

                    </Menu.Item>

                  </Menu>
                </Header>
                :
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    zIndex: 200
                  }}
                >
                  <Sider
                    collapsed={false}
                  >
                    <Menu
                      onClick={(e) => {
                        // e.domEvent.stopPropagation()
                        this.setState({ collapsed: true })
                      }}
                      style={{
                        width: "100vw",
                        height: "100vh"
                      }}
                      mode="inline"
                      key="menuMain"
                      theme="dark"
                    >

                      <Menu.Item icon={<CloseOutlined />}
                      >
                        {GetTranslation(userlang, "Close Menu")}
                      </Menu.Item>

                      {categories.map((category, index) => {
                        if (this.context.UserIdentity.userType === "Root" ||
                          useraccess.filter(x => this.context.UserIdentity.userid == x).length > 0) {
                          if (this.context.UserIdentity.userType != "Root" && this.context.UserIdentity.userid != "root" && category.key == 13) { }
                          else {
                            return (
                              <>
                                <SubMenu
                                  key={index.toString() + category.key.toString()} icon={category.icon} title={category.title}
                                >
                                  {pages.map((page, index) => {
                                    if (page.parent === category.title) {
                                      if ((this.context.UserIdentity.userid == "60ebf3b2e0741b107ce0d8a6" || this.context.UserIdentity.userid == "60ebf1d6aebe39153046d6d6") && category.key == 0 && page.title != "Attendance") { }
                                      else if ((this.context.UserIdentity.userid == "60ebf38ae0741b107ce0d89e" || this.context.UserIdentity.userid == "60ebf235e0741b107ce0d855" || this.context.UserIdentity.userid == "60ebf36ae0741b107ce0d89a" || this.context.UserIdentity.userid == "60ec1a20e840169d91254cc8") && category.key == 0 && page.title != "Branch") { }
                                      else {
                                        return (
                                          <Menu.Item
                                            key={index + page.key} icon={page.icon} >
                                            <NavLink to={page.path}>
                                              {page.title}
                                            </NavLink>
                                          </Menu.Item>
                                        )
                                      }
                                    }
                                  }
                                  )}
                                </SubMenu>
                              </>
                            )
                          }
                        }
                        else if (this.context.UserIdentity.companyid === "outsider") {
                          if (category.key == 12) {
                            return (
                              <>
                                <SubMenu
                                  key={index.toString() + category.key.toString()} icon={category.icon} title={category.title}
                                >
                                  {pages.map((page, index) => {
                                    if (page.parent === category.title) {
                                      return (
                                        <Menu.Item
                                          key={index + page.key} icon={page.icon} >
                                          <NavLink to={page.path}>
                                            {page.title}
                                          </NavLink>
                                        </Menu.Item>
                                      )
                                    }
                                  }
                                  )}
                                </SubMenu>
                              </>
                            )
                          }
                        }
                        else {
                          if (category.key != 0) {
                            if (this.context.UserIdentity.userType != "Root" && category.key == 13) { }
                            else {
                              return (
                                <>
                                  <SubMenu
                                    key={index.toString() + category.key.toString()} icon={category.icon} title={category.title}
                                  >
                                    {pages.map((page, index) => {
                                      if (page.parent === category.title) {
                                        return (
                                          <Menu.Item
                                            key={index + page.key} icon={page.icon} >
                                            <NavLink to={page.path}>
                                              {page.title}
                                            </NavLink>
                                          </Menu.Item>
                                        )
                                      }
                                    }
                                    )}
                                  </SubMenu>
                                </>
                              )
                            }
                          }
                        }

                        // if (this.context.UserIdentity.permission[0] === "Root") {
                        //   return (
                        //     <>
                        //       <SubMenu
                        //         key={index.toString() + category.key.toString()} icon={category.icon} title={category.title}>
                        //         {pages.map((page, index) => {
                        //           if (page.parent === category.title) {
                        //             return (
                        //               <Menu.Item
                        //                 key={index + page.key} icon={page.icon} >
                        //                 <NavLink to={page.path}>
                        //                   {page.title}
                        //                 </NavLink>
                        //               </Menu.Item>
                        //             )
                        //           }
                        //         }
                        //         )}

                        //       </SubMenu>
                        //     </>)
                        // }
                        // else {
                        //   return (

                        //     this.context.UserIdentity.permission.some(permission => category.childs.includes(permission)) ?
                        //       <>
                        //         <SubMenu
                        //           key={index.toString() + category.key.toString()}
                        //           icon={category.icon} title={category.title}>
                        //           {pages.map((page, index) => {
                        //             if (page.parent === category.title && this.context.UserIdentity.permission.includes(page.key)) {
                        //               return (
                        //                 <Menu.Item key={index + page.key} icon={page.icon} >
                        //                   <NavLink to={page.path}>
                        //                     {page.title}
                        //                   </NavLink>
                        //                 </Menu.Item>
                        //               )
                        //             }
                        //           }
                        //           )}

                        //         </SubMenu>
                        //       </> : null
                        //   )
                        // }
                      })}
                      <Menu.Item icon={<TableOutlined />} onClick={handleUserManualMenuClick}>

                        User Manual

                      </Menu.Item>
                    </Menu>
                  </Sider>

                </div>
            }
          </>
          :
          //Desktop
          <Header
            key="GLIVETURBOHEADER"
          >
            <Menu
              key="menuMain"
              theme="dark"
              mode="horizontal">

              <SubMenu
                style={{ float: "right" }}
                title={" " + this.context.UserIdentity.username} key={"Logggout"}
                icon={
                  pendingContact > 0 ?


                    <Avatar
                      style={{
                        backgroundColor: '#7265e6',
                        verticalAlign: "middle",
                        cursor: "pointer"
                      }}
                      size="large">
                      {this.context.UserIdentity.username[0]}
                      {this.context.UserIdentity.username[1]}
                    </Avatar>

                    :

                    <Avatar
                      style={{
                        backgroundColor: '#7265e6',
                        verticalAlign: "middle",
                        cursor: "pointer"
                      }}
                      size="large">
                      {this.context.UserIdentity.username[0]}
                      {this.context.UserIdentity.username[1]}
                    </Avatar>

                }>
                {this.profileContact}
                {this.profileN}
                {logoutN}
              </SubMenu>
              {dashboardpages.map((category, index) => {

                return (
                  <>
                    <Menu.Item key={index.toString() + category.key.toString()} icon={category.icon} >
                      <NavLink to={category.path}>

                      </NavLink>
                    </Menu.Item>
                  </>
                )
              }
              )}
              {
                // paymentpages.map((category, index) => {
                //   if (usertesting.filter(x => this.context.UserIdentity.userid == x).length > 0) {
                //     return (
                //       <>
                //         <Menu.Item key={index.toString() + category.key.toString()} icon={category.icon} >
                //           <NavLink to={category.path}>

                //           </NavLink>
                //         </Menu.Item>
                //       </>
                //     )
                //   }

                // }
                // )

                <Menu.Item>
                  <a href="/TaskManagement" onClick={() => onPressNewTask()}><AliwangwangOutlined /></a>
                </Menu.Item>
              }

              {contactlistpages.map((category, index) => {

                return (
                  <>
                    <Menu.Item key={index.toString() + category.key.toString()} icon={category.icon} >
                      <NavLink to={category.path}>
                        {
                          pendingContact > 0 ?
                            <>
                              <Badge badgeContent={pendingContact} color="success">

                              </Badge>
                            </>
                            :
                            <>
                            </>
                        }
                      </NavLink>
                    </Menu.Item>
                  </>
                )
              }
              )}


              {/* {remidnerdpages.map((category, index) => {

                return (
                  <>
                    <Menu.Item key={index.toString() + category.key.toString()} icon={category.icon} >
                      <NavLink to={category.path}>

                      </NavLink>
                    </Menu.Item>
                  </>
                )
              }
              )} */}

              {taskpages.map((category, index) => {
                if (this.context.UserIdentity.companyid === "outsider") {
                  return (
                    <>
                      <Menu.Item key={index.toString() + category.key.toString()} icon={category.icon} >
                        <NavLink to={category.path}>

                        </NavLink>
                      </Menu.Item>
                    </>
                  )
                }

              }
              )}
              {categories.map((category, index) => {
                if (this.context.UserIdentity.userType === "Root" || useraccess.filter(x => this.context.UserIdentity.userid == x).length > 0) {
                  return (
                    <>
                      <SubMenu
                        key={index.toString() + category.key.toString()}
                        icon={category.icon} title={category.title}>
                        {pages.map((page, index) => {
                          if (page.parent === category.title) {
                            if ((this.context.UserIdentity.userid == "60ebf3b2e0741b107ce0d8a6" || this.context.UserIdentity.userid == "60ebf1d6aebe39153046d6d6") && category.key == 0 && page.title != "Attendance" && page.title != "Holiday") {
                              //   if(page.key =='2016' || page.key =='2017' || page.key =='2018')
                              //       {
                              //         return (
                              //           <Menu.Item key={index + page.key} icon={page.icon} >
                              //             <NavLink to={page.path}>
                              //               {page.title}
                              //             </NavLink>
                              //           </Menu.Item>
                              //         )
                              //       }

                            }
                            else if ((this.context.UserIdentity.userid == "60ebf38ae0741b107ce0d89e" || this.context.UserIdentity.userid == "60ebf235e0741b107ce0d855" || this.context.UserIdentity.userid == "60ebf36ae0741b107ce0d89a" || this.context.UserIdentity.userid == "60ec1a20e840169d91254cc8") && category.key == 0 && page.title != "Branch") { }
                            else if (this.context.UserIdentity.userType !== "Root" && category.key == 13) {
                              if (page.key == "2009") {
                                return (
                                  <Menu.Item key={index + page.key} icon={page.icon} >
                                    <NavLink to={page.path}>
                                      {page.title}
                                    </NavLink>
                                  </Menu.Item>
                                )
                              }
                              if (page.key == "2007") {
                                if (this.context.UserIdentity.userid == "62b285b616cfa6b8352cd44a") // Stevent ID
                                {
                                  return (
                                    <Menu.Item key={index + page.key} icon={page.icon} >
                                      <NavLink to={page.path}>
                                        {page.title}
                                      </NavLink>
                                    </Menu.Item>
                                  )
                                }
                              }
                            }
                            else {
                              return (
                                <Menu.Item key={index + page.key} icon={page.icon} >
                                  <NavLink to={page.path}>
                                    {page.title}
                                  </NavLink>
                                </Menu.Item>
                              )
                            }


                          }

                        }

                        )}
                      </SubMenu>
                    </>
                  )
                }

                else if (this.context.UserIdentity.companyid === "outsider") {
                  if (category.key == 12) {
                    return (
                      <>
                        <SubMenu
                          key={index.toString() + category.key.toString()} icon={category.icon} title={category.title}
                        >
                          {pages.map((page, index) => {
                            if (page.parent === category.title) {
                              return (
                                <Menu.Item
                                  key={index + page.key} icon={page.icon} >
                                  <NavLink to={page.path}>
                                    {page.title}
                                  </NavLink>
                                </Menu.Item>
                              )
                            }
                          }
                          )}
                        </SubMenu>
                      </>
                    )
                  }
                }
                else {
                  if (category.key != 0) {
                    if (this.context.UserIdentity.userType != "Root" && this.context.UserIdentity.userid != "root" && (category.key == 13 || category.key == 99)) { }
                    else {
                      return (
                        <SubMenu
                          key={index.toString() + category.key.toString()}
                          icon={category.icon} title={category.title}>
                          {pages.map((page, index) => {
                            if (page.parent === category.title) {
                              return (
                                <Menu.Item key={index + page.key} icon={page.icon} >
                                  <NavLink to={page.path}>
                                    {page.title}
                                  </NavLink>
                                </Menu.Item>
                              )
                            }
                          })}
                        </SubMenu>
                      )
                    }
                  }
                }
                // if(userpayeesetting.filter(x => this.context.UserIdentity.userid == x).length > 0)
                // {
                //   return (
                //     <>
                //       <SubMenu
                //         key={index.toString() + category.key.toString()}
                //         icon={category.icon} title={category.title}>
                //           {pages.map((page, index) => {
                //              if(page.key =='2016' || page.key =='2017' || page.key =='2018')
                //              {
                //                return (
                //                  <Menu.Item key={index + page.key} icon={page.icon} >
                //                    <NavLink to={page.path}>
                //                      {page.title}
                //                    </NavLink>
                //                  </Menu.Item>
                //                )
                //              }
                //           }
                //           )}
                //           </SubMenu>
                //       </>
                //       )



                // }


                //   if (this.context.UserIdentity.permission[0] === "Root") {
                //     return (
                //       <>
                //         <SubMenu
                //           key={index.toString() + category.key.toString()}
                //           icon={category.icon} title={category.title}>
                //           {pages.map((page, index) => {
                //             if (page.parent === category.title) {
                //               return (
                //                 <Menu.Item key={index + page.key} icon={page.icon} >
                //                   <NavLink to={page.path}>
                //                     {page.title}
                //                   </NavLink>
                //                 </Menu.Item>
                //               )
                //             }
                //           }
                //           )}
                //         </SubMenu>
                //       </>)
                //   }
                //   else {
                //     return (
                //       this.context.UserIdentity.permission.some(permission => category.childs.includes(permission)) ?
                //         <>
                //           <SubMenu
                //             key={index.toString() + category.key.toString()}
                //             icon={category.icon} title={category.title}>
                //             {pages.map((page, index) => {
                //               if (page.parent === category.title && this.context.UserIdentity.permission["0"].includes(page.key)) {
                //                 return (
                //                   <Menu.Item key={index + page.key} icon={page.icon} >
                //                     <NavLink to={page.path}>
                //                       {page.title}
                //                     </NavLink>
                //                   </Menu.Item>
                //                 )
                //               }
                //             }
                //             )}

                //           </SubMenu>
                //         </> : null
                //     )
                //   }
              })}
              <Menu.Item icon={<TableOutlined />} onClick={handleUserManualMenuClick}>

                User Manual

              </Menu.Item>
              {testpages.map((category, index) => {
                if (this.context.UserIdentity.userType == "Root") {
                  return (
                    <>
                      <Menu.Item key={index.toString() + category.key.toString()} icon={category.icon} >
                        <NavLink to={category.path}>
                          {category.title}
                        </NavLink>
                      </Menu.Item>
                    </>
                  )
                }
              })}

            </Menu>
          </Header>
        }

      </>

    )
  }
}

export default App;
